import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './LoginPage';
import DashboardPage from './DashboardPage';
import GeneralPage from './GeneralPage';
import ProductionPage from './ProductionPage';
import InventoryMaterialsPage from './InventoryMaterialsPage';
import InventoryProducts from './InventoryProducts';
import WorkPerformancePage from './WorkPerformancePage';
import ShipmentsPage from './ShipmentsPage';
import OrdersPage from './OrdersPage';
import EmployeePage from './EmployeePage';
import ManagerPage from './ManagerPage';
import AccessDeniedPage from './AccessDeniedPage';
import ForgotPasswordPage from './Forgot_Password';
import PrivateRoute from './PrivateRoute';
import { PermissionsProvider } from './PermissionsContext';
import ScannersMenu from './ScannersMenu';
import ScannersInvSeeds from './ScannersInvSeeds';
import ScannersInvSets from './ScannersInvSets';
import ScannersUnsealed from './ScannersTranserUnsealed';
import ScannersShipments from './ScannersShipments';
import ScannersInvMaterials from './ScannersInvMaterials';
import ScannersNotFullBoxesSB from './ScannersNotFullBoxesSB';
// import SetsComposition from './SetsComposition';
import ScannersAmazonShipments from './ScannersAmazonShipments';
import MaterialOrderPlanning from './MaterialOrderPlanning';
import SalesForecastPage from './SalesForecast';
import PlanToProducePage from './PlanToProducePage';
import ProductionPlanPage from './ProductionPlanPage';
import DailyPlanning from './DailyPlanning'
import ScannersSeedStockComparsion from './ScannersSeedStockComparsion';
import ScannersInvFert from './ScannersInvFert';
import InventoryFBA from './InventoryFBA';
import AmazonInventoryReportPage from './AmazonInventoryReportPage';
import AmazonDealsPage from './AmazonDealsPage';
import OrdersPackagesPage from './OrdersPackagesScan';
import YOYForecastPage from './YOYForecast'
import ProductCOGSPage from './ProductCOGSPage'
import MaterialOrdersPage from './MaterialOrdersPage'
import GetLabelsPage from './GetLabelsPage'
import GoodsOrderedReportPage from './GoodsOrderedReportPage'
import SeedsReceivingReportPage from './SeedsReceivingReportPage'
import InventoryConsumptionReportPage from './InventoryConsumptionReportPage'
import ShipmentsPlanningPage from './ShipmentsPlanningPage'
import RolesPermissionsPage from './RolesPermissionsPage'
import AuditLogPage from './AuditLogPage'
import AdminUsersPage from './AdminUsersPage'
import ResetPasswordPage from './ResetPasswordPage'
import RequestAccessPage from './RequestAccessPage'
import AccessRequestsPage from './AccessRequestsPage'
import DocsPage from './DocsPage'

function App() {
  return (
    <Router>
      <PermissionsProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin/users" element={<PrivateRoute page="admin-users" element={<AdminUsersPage />} />} />
        <Route path="/admin/requests" element={<PrivateRoute page="admin-users" element={<AccessRequestsPage />} />} />
        <Route path="/admin/roles" element={<PrivateRoute page="admin-roles" element={<RolesPermissionsPage />} />} />
        <Route path="/admin/audit" element={<PrivateRoute page="admin-audit" element={<AuditLogPage />} />} />
        <Route path="/docs" element={<PrivateRoute page="docs" element={<DocsPage />} />} />
        <Route path="/dashboard" element={<PrivateRoute page="dashboard" element={<DashboardPage />} />} />
        <Route path="/general" element={<PrivateRoute page="general" element={<GeneralPage />} />} />
        <Route path="/production/:tab?" element={<PrivateRoute page="production" element={<ProductionPage />} />} />
        <Route path="/inventory-materials" element={<PrivateRoute page="inventory-materials" element={<InventoryMaterialsPage />} />} />
        <Route path="/inventory-products" element={<PrivateRoute page="inventory-products" element={<InventoryProducts />} />} />
        <Route path="/work-performance" element={<PrivateRoute page="work-performance" element={<WorkPerformancePage />} />} />
        <Route path="/shipments" element={<PrivateRoute page="shipments" element={<ShipmentsPage />} />} />
        <Route path="/scanners" element={<PrivateRoute page="scanners" element={<ScannersMenu />} />} />
        <Route path="/get-labels/:tab?" element={<PrivateRoute page="get-labels" element={<GetLabelsPage />} />} />
        <Route path="/scannerinvseeds" element={<PrivateRoute page="scanner-inv-seeds" element={<ScannersInvSeeds />} />} />
        <Route path="/scannerinvfert" element={<PrivateRoute page="scanner-inv-fert" element={<ScannersInvFert />} />} />
        <Route path="/scannerinvseedsstockcheck" element={<PrivateRoute page="scanner-seeds-stock-check" element={<ScannersSeedStockComparsion />} />} />
        <Route path="/scannersealedsets" element={<PrivateRoute page="scanner-sealed-sets" element={<ScannersInvSets />} />} />
        <Route path="/scannerunsealedsets" element={<PrivateRoute page="scanner-unsealed-sets" element={<ScannersUnsealed />} />} />
        <Route path="/scannershipments" element={<PrivateRoute page="scanner-shipments" element={<ScannersShipments />} />} />
        <Route path="/scannerainvmaterials" element={<PrivateRoute page="scanner-inv-materials" element = {<ScannersInvMaterials />}/>} />
        <Route path="/scannernotfullboxes" element={<PrivateRoute page="scanner-not-full-boxes" element = {<ScannersNotFullBoxesSB />}/>} />
        <Route path="/scanners-amazon-shipments" element={<PrivateRoute page="scanner-amazon-shipments" element = {<ScannersAmazonShipments />}/>} />
        <Route path="/material-order-planning" element={<PrivateRoute page="material-order-planning" element = {<MaterialOrderPlanning />}/>} />
        <Route path="/orders-scan" element={<PrivateRoute page="orders-scan" element = {<OrdersPackagesPage />}/>} />
        <Route path="/sales-forecast" element={<PrivateRoute page="sales-forecast" element = {<SalesForecastPage />}/>} />
        <Route path="/plan-to-produce" element={<PrivateRoute page="plan-to-produce" element = {<PlanToProducePage />}/>} />
        <Route path="/daily-planning" element={<PrivateRoute page="daily-planning" element = {<DailyPlanning />}/>} />
        <Route path="/production-plan" element={<PrivateRoute page="production-plan" element={<ProductionPlanPage />} />} />
         <Route path="/yoy-forecast" element={<PrivateRoute page="yoy-forecast" element = {<YOYForecastPage />}/>} />
        <Route path="/product-cogs/:tab?" element={<PrivateRoute page="product-cogs" element={<ProductCOGSPage />} />} />
        <Route path="/material-orders/:tab/:orderID" element={<PrivateRoute page="material-orders" element={<MaterialOrdersPage />} />} />
        <Route path="/material-orders/:tab?" element={<PrivateRoute page="material-orders" element={<MaterialOrdersPage />} />} />
        <Route path="/shipments-planning" element={<PrivateRoute page="shipments-planning" element={<ShipmentsPlanningPage />} />} />
        <Route path="/amazon-deals" element={<PrivateRoute page="amazon-deals" element={<AmazonDealsPage />} />} />
        <Route path="/reports/goods-ordered" element={<PrivateRoute page="goods-ordered-report" element={<GoodsOrderedReportPage />} />} />
        <Route path="/reports/seeds-receiving" element={<PrivateRoute page="seeds-receiving-report" element={<SeedsReceivingReportPage />} />} />
        <Route path="/reports/inventory-consumption" element={<PrivateRoute page="inventory-consumption-report" element={<InventoryConsumptionReportPage />} />} />
        <Route path="/orders" element={<PrivateRoute page="orders" element={<OrdersPage />} />} />
        <Route path="/employee" element={<PrivateRoute element={<EmployeePage />} />} />
        <Route path="/manager" element={<PrivateRoute element={<ManagerPage />} />} />
        {/* <Route path="/sets-composition" element={<PrivateRoute element={<SetsComposition />} />} /> */}
        <Route path="/inventory-fba" element={<PrivateRoute page="inventory-fba" element={<InventoryFBA />} />} />
        <Route path="/inventory-fba/report" element={<PrivateRoute page="inventory-fba" element={<AmazonInventoryReportPage />} />} />
        <Route path="/accessdenied" element={<PrivateRoute element={<AccessDeniedPage />} />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />}/>
        <Route path="/reset-password/:token" element={<ResetPasswordPage />}/>
        <Route path="/sign-up" element={<RequestAccessPage />}/>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="*" element={<Navigate to="/login" />} /> {/* Обработка неопределенных маршрутов */}


      </Routes>
      </PermissionsProvider>
    </Router>
  );
}

export default App;
